import Vue from 'vue';
export const Bus = new Vue();
